import Lottie from 'lottie-react';
import { ButtonVariant } from '@/shared/components/Buttons/types';
import { Button } from '@/shared/components/Buttons';
import { useViewErrorScreen } from '@/epics/subscriptionManagment/hooks/useViewErrorScreen';

const ViewSubscriptionPlanErrorScreen = () => {
  const { animationData, isLoading, handleReload } = useViewErrorScreen();

  return (
    <div className="flex flex-col items-center gap-5 justify-center h-screen bg-white">
      {animationData && !isLoading ? (
        <Lottie
          animationData={animationData}
          loop={false}
          style={{
            width: '30%',
            height: '30%',
          }}
        />
      ) : (
        <div
          className="flex items-center justify-center"
          style={{ width: '50%', height: '50%' }}
        >
          <div className="text-gray-400">Ładowanie...</div>
        </div>
      )}
      <div className="flex flex-col items-center justify-center gap-1">
        <h1
          className="text-bodyLarge font-medium text-center"
          style={{
            color: '#474A4C',
          }}
        >
          Coś poszło nie tak...
        </h1>
        <p className="text-bodyLarge text-on-surface-variant text-center">
          Nie udało się w tej chwili załadować szczegółów planu.
        </p>
      </div>
      <Button
        label="Odśwież"
        className="hover:cursor-pointer"
        variant={ButtonVariant.Primary}
        size="Small"
        onClick={handleReload}
      />
    </div>
  );
};

export default ViewSubscriptionPlanErrorScreen;
